// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"089e5dc1","239":"e0b7a9ee","453":"9092cd1f","455":"8f5291f8"}[chunkId] + ".chunk.js";
};